export const uuid = {
  type: "string",
  format: "uuid"
};
